<template>
<div>
    <transition name="fade">
        <div><slot v-bind="{ visible, show, showIfNotEmpty, hide, toggle }"></slot></div>
    </transition>
</div>
</template>

<script>
export default {
    name: 'toggle-visibility',
    props: ['initialVisible'],

    data: () => ({
        visible: false,
    }),

    watch: {
        visible() {
            this.$emit('visiblity-changed', this.visible);
        }
    },

    mounted() {
        if(this.initialVisible != '') {
            this.visible = this.initialVisible;
        }
    },

    methods: {
       show() {
           this.visible = true;
       },

       hide() {
           this.visible = false;
       },

       showIfNotEmpty(value) {
           if(value == '') {
               return this.hide()
           }

           return this.show();
       },

       toggle() {
           this.visible = !this.visible;
       }
    }
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
